import env from '../core/env'
import FusionClass from '@didi/fusion'
import { dbridge } from '@didi/driver-bridge'

// const dbridgeUrl = '//webapp.didistatic.com/static/webapp/1.3.14/dbridge.js'

let bridge = ''

if (env.is('fusion')) {
  bridge = new FusionClass(['DidiBridgeAdapter', 'TraceModule'])
} else {
  // 非Fusion环境 降级使用bridge兼容
  bridge = dbridge
}

// core.sdkReady('dbridge', dbridgeUrl, sdk => {
//   bridge = sdk
// }, 'DidiJSBridgeReady')
export default bridge
